import { type AddressTypeDto, SUPPORTED_PLACE_TYPES, type SupportedPlaceType } from '@ev-tech/search-modules-api';

export const isSupportedAddressType = (type: AddressTypeDto): type is SupportedPlaceType => {
  return SUPPORTED_PLACE_TYPES.has(type as SupportedPlaceType);
};
